<template>
  <div
    id="app"
    class="h-100"
    :class="[skinClasses]"
  >
    <component :is="layout">
      <router-view />
    </component>

  </div>
</template>

<script>

// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { provideToast } from 'vue-toastification/composition'
import { watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

import { useWindowSize, useCssVar } from '@vueuse/core'

import store from '@/store'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutHorizontal = () => import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')
const Frontend = () => import('@/views/frontend/Index.vue')

export default {
  components: {

    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
    Frontend,
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full'
      if (this.$route.meta.layout === 'frontend') return 'frontend'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
  },
  methods: {
    playSound(sound) {
      if (sound) {
        const audio = new Audio(sound)
        audio.play()
      }
    },
  },
  created() {
    // setInterval(() => {
    //   const codes = JSON.parse(localStorage.getItem('packetCodes')) ?? []
    //   if (codes.length > 0) {
    //     this.$http.post('https://tojtel.tj/api/dealer/connected-packets/check', {
    //       codes,
    //     }, {}).then(response => {
    //       const {
    //         data,
    //       } = response
    //       // eslint-disable-next-line no-plusplus
    //       for (let i = 0; i < data.length; i++) {
    //         const codes2 = JSON.parse(localStorage.getItem('packetCodes')) ?? []
    //         codes2.splice(codes2.indexOf(data[i].code), 1)
    //         localStorage.setItem('packetCodes', JSON.stringify(codes2))
    //         this.playSound('https://tojtel.tj/sound/notification.mp4')
    //         if (data[i].status === 1) {
    //           this.$toast({
    //             component: ToastificationContent,
    //             position: 'top-right',
    //             timeout: 100000,
    //             props: {
    //               title: `${data[i].msisdn} - ${data[i].packet}`,
    //               icon: 'CheckIcon',
    //               variant: 'success',
    //               text: data[i].comment,
    //             },
    //           })
    //         } else if (data[i].status === 0) {
    //           this.$toast({
    //             component: ToastificationContent,
    //             position: 'top-right',
    //             timeout: 30000,
    //             props: {
    //               title: `${data[i].msisdn} - ${data[i].packet}`,
    //               icon: 'XIcon',
    //               variant: 'danger',
    //               text: 'Ошибки при подключение пакета',
    //             },
    //           })
    //         } else {
    //           this.$toast({
    //             component: ToastificationContent,
    //             position: 'top-right',
    //             timeout: 30000,
    //             props: {
    //               title: `${data[i].msisdn} - ${data[i].packet}`,
    //               icon: 'XIcon',
    //               variant: 'danger',
    //               text: data[i].comment ? data[i].comment : 'Ошибки при подключение пакета',
    //             },
    //           })
    //         }
    //       }
    //     }).catch()
    //   }
    // }, 50000)
  },
  beforeCreate() {
    // Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2))
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },
  setup() {
    const { skin, skinClasses } = useAppConfig()

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
    }
  },
}
</script>
